import { faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import { useLanguage } from "../../contexts/LanguageContext";
import Header from "../Header/Header";

const NotEvents = () => {
  const { t } = useLanguage();
  return (
    <div className="event-dashboard-page">
      <Header />
      <div className="dashboard-layout">
        <div className="dashboard-main no-events">
          <div className="container">
            <div className="no-events-dashboard">
              <FontAwesomeIcon icon={faImage} size="4x" />
              <div className="no-events-content">
                <h2 style={{ marginTop: "20px" }}>
                  {t("notEventError.text2")}
                </h2>
                <p>{t("notEventError.text3")}</p>
                <Link to="/create-event" className="btn btn-primary">
                  {t("notEventError.text4")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotEvents;
